import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function CategoryNav() {
  return (
    <section className="w-full bg-background-50 py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">
            探索内容分类
          </h2>
          <p className="text-sm text-foreground-500">
            八大内容板块，总有一款适合你
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-3 p-4 md:p-5 rounded-xl bg-background-100 hover:bg-primary-100 transition-all duration-300 cursor-pointer group"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-background-200 group-hover:bg-primary-200 flex items-center justify-center transition-colors">
                <i className={`${cat.icon} text-foreground-700 group-hover:text-primary-600 text-xl md:text-2xl transition-colors`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}